import { fullFormats } from 'ajv-formats/dist/formats.js';
import type { TNumberRange } from '#utils/number/index.ts';

const emailFormat = fullFormats.email as RegExp;

export const getNameInitials = (name = ''): string =>
  name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');

export const isValidEmail = (email: string): boolean =>
  emailFormat.test(email.trim());

export const equalsIgnoreCase = (first: string, second: string): boolean =>
  first.toLowerCase() === second.toLowerCase();

export const capitalize = (text: string, locale: string): string =>
  text.charAt(0).toLocaleUpperCase(locale) + text.slice(1);

export const parseJson = (text?: string): unknown => {
  if (text === undefined) {
    return undefined;
  }

  try {
    return JSON.parse(text);
  } catch {
    return undefined;
  }
};

export const isTextLengthWithin = (
  text: string,
  { min = 0, max = Infinity }: TNumberRange = {},
): boolean => {
  const { length } = text.trim();

  return length >= min && length <= max;
};
